import React, { Component } from 'react';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import services from '@C/Director/Utils/_utils/data';
import { TableGrid } from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';

const col = [
  {
    name: 'Product Catogory',
    key: 'name',
  },
];

const enabledActions = [
  // {
  //   action: 'Delete',
  //   roles: ['DIRECTOR'],
  // },
  // {
  //   action: 'Edit',
  //   roles: ['DIRECTOR'],
  // },
];

export default class ProductList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productList: [],
      loading: true,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getProductList();
  }

  getProductList = () => {
    services
      .getProductList()
      .then((response) => {
        this.setState({
          productList: response.data.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const { productList } = this.state;
    return (
      <section className="widget full-width list-table">
        <header>
          <h3>Product Catogories List </h3>
        </header>
        <main className="list-content">
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    <TableGrid
                      col={col}
                      row={productList}
                      pagination="disabled"
                      enableExport={false}
                      onEdit={this.props.onEdit}
                      //   onDelete={this.confirmDelete}
                      enabledActions={enabledActions}
                      hideActions={true}
                    />
                  </>
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}
